"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const isObject_1 = require("../predicates/isObject");
exports.object = (predicate) => (value) => {
    const isObjectValue = isObject_1.isObject(value);
    if (isObjectValue) {
        for (const key in value) {
            if (Object.hasOwnProperty.call(value, key)) {
                if (!predicate(value[key])) {
                    return false;
                }
            }
        }
    }
    return isObjectValue;
};
//# sourceMappingURL=object.js.map